module.exports = __webpack_public_path__ + "static/media/Slice24@2x.7fd98cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice24@2x.png
// module id = 1452
// module chunks = 0